<template>
    <div class="not-found page section section__cover">
        <div class="uk-container uk-container-large section__container">
            <div class="changing-text" :class="{'is-active': isActive}">
                <div class="changing-text__main">
                    <span>Страница</span>
                </div>
                <div class="changing-text__usual">
                    <span>не существует</span>
                </div>
                <div class="changing-text__main">
                    <span>Не найдена</span>
                </div>
            </div>
        </div>
        <carousel-ticker 
            v-if="tags"
            theme="dark"
            :data="tags"
            @getItem="tagItem = $event.item"
            style="top: -40px"
        />
    </div>
</template>

<script>
import carouselTicker from '@/components/carousel-ticker/CarouselTicker'
import utils from '@/utils.js'

export default {
    components: {
        carouselTicker
    },
    data() {
        return {
            isActive: false,
            tags: null,
            tagItem: null,
        }
    },
    methods: {
        async getInitTags() {
            const { fetchData } = utils()
            let api = 'tag'
            let response = await fetchData('get', api)
            this.tags = response?.data
        },
    },
    watch: {
        tagItem() {
            this.$router.push({
                name: 'articles',  
                query: {
                    tag: this.tagItem.id
                }
            })
        }
    },
    async mounted() {
        this.getInitTags()
        await this.$nextTick()

        setTimeout(() => {
            this.isActive = true
        }, 100)
    },
    metaInfo: {
        title: 'Страница не найдена',
        titleTemplate: `%s - ${process.env.VUE_APP_NAME}`,
    },
}
</script>